exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:1110px){.preview-box-body .screenPdf .section-control .section-zoom-area .zoom-out{margin:0 10px 0 0}.preview-box-body .screenPdf .section-control .section-zoom-area .zoom-num{display:none}.preview-box-body .screenPdf .section-control .section-rotate-area .rotate-ccw{margin:0 10px 0 0}.preview-box-body .screenPdf .section-down{margin-left:0!important}.preview-box-body .screenPdf .section-down .switch-list{margin-right:0!important}}", ""]);

// exports
